exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".marquee[data-v-44ed0197]{z-index:999;position:absolute;bottom:30px;left:50%;-webkit-transform:translate(-50%);transform:translate(-50%)}", ""]);

// exports
